import dayjs from 'dayjs';
import { FC } from 'react';

import { DATE_FORMAT } from 'consts';

import { ExtendedDescriptions, StatusTag } from 'components';

import { TabProps } from '../../types';

const Summary: FC<TabProps> = ({ company }) => (
  <ExtendedDescriptions
    items={[
      {
        label: 'common.name',
        value: company.name,
      },
      {
        label: 'common.type',
        value: company.type,
      },
      {
        label: 'company.acn',
        value: company.acn,
      },
      {
        label: 'date.registeredAt',
        value:
          company.registeredAt &&
          dayjs(company.registeredAt).format(DATE_FORMAT),
      },
      {
        label: 'common.status',
        value: <StatusTag id={company.statusID} name={company.status} />,
      },
    ]}
  />
);

export default Summary;
